import { createContext } from "react";

/**
 * Provides the date (ms or ISO string) a task alert finished so every
 * TaskAlertCard can render it in the same position without each item
 * having to forward it.
 */
const TaskAlertTimestampContext = createContext(null);

export default TaskAlertTimestampContext;
